import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { TablePage } from "@outpave/ds";
import ApiKeyManagement from "components/admin/apiKeys/ApiKeyManagement";
import useGetLoggedInUser from "hooks/useGetLoggedInUser";
import ApiKeyScope from "enums/ApiKeyScope";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";

/** API Access as its own route (OUT-1379); it was a tab on Company Settings. */
const ApiAccess: React.FC = () => {
  const { t } = useTranslation();
  const { user: loggedInUser } = useGetLoggedInUser();
  const breadcrumbs = useNavBreadcrumbs(t("API Access"));
  const [createOpen, setCreateOpen] = useState(false);

  const companyId = loggedInUser?.companyId;

  return (
    <TablePage
      breadcrumbs={breadcrumbs}
      title={t("API Access")}
      subtitle={t("API Access section description")}
      primaryAction={
        <Button
          variant="primary-filled"
          onClick={() => setCreateOpen(true)}
          disabled={!companyId}
        >
          {t("Create API key")}
        </Button>
      }
    >
      {companyId && (
        <ApiKeyManagement
          scope={ApiKeyScope.COMPANY}
          ownerId={companyId}
          createOpen={createOpen}
          onCreateOpenChange={setCreateOpen}
        />
      )}
    </TablePage>
  );
};

export default ApiAccess;
